const drawerEl = document.getElementById('mobile-menu-drawer');
const toggleBtn = document.querySelector('[data-mobile-menu-toggle]');

toggleBtn?.addEventListener('click', () => drawerEl?.open(toggleBtn));

drawerEl?.querySelectorAll('.mobile-menu-drawer__tab').forEach((tab) => {
  tab.addEventListener('click', () => {
    drawerEl.querySelectorAll('.mobile-menu-drawer__tab').forEach((t) => {
      t.classList.remove('is-active');
      t.setAttribute('aria-selected', 'false');
    });
    tab.classList.add('is-active');
    tab.setAttribute('aria-selected', 'true');

    const name = tab.dataset.tab;
    drawerEl.querySelectorAll('.mobile-menu-drawer__panel').forEach((panel) => {
      panel.hidden = panel.dataset.panel !== name;
    });
  });
});
